
import { useState } from 'react';
import Button from '../base/Button';

export default function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-xl border-b border-gray-200/20 z-50 shadow-lg">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/5f53e0b0b7932ac58bfb3ea1730e8762.png" 
              alt="Flyte Logo" 
              className="h-14 w-auto"
            />
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-[#2C2CE8] transition-colors cursor-pointer font-medium"
            >
              About Us
            </button>
            <Button 
              onClick={() => scrollToSection('waitlist')}
              size="sm"
              className="text-white shadow-lg whitespace-nowrap"
            >
              <i className="ri-rocket-line mr-2"></i>
              Join the Waitlist
            </Button>
          </div>

          {/* Mobile menu button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-white z-40 md:hidden">
          <div className="pt-20 px-6">
            <div className="space-y-6">
              <button 
                onClick={() => scrollToSection('about')}
                className="block w-full text-left text-xl font-medium text-gray-700 hover:text-[#2C2CE8] py-3"
              >
                About Us
              </button>
              <div className="pt-6">
                <Button 
                  onClick={() => scrollToSection('waitlist')}
                  size="lg"
                  className="w-full text-white shadow-lg whitespace-nowrap"
                >
                  <i className="ri-rocket-line mr-2"></i>
                  Join the Waitlist
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
